console.log("PRODUCT RECOMMENDATIONS")

if (!customElements.get("product-recommendations")) {
  customElements.define(
    "product-recommendations",
    class extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return
          observer.unobserve(this)

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              // Create a temporary container to parse the fetched HTML
              const tempDiv = document.createElement("div")
              tempDiv.innerHTML = text

              // Find the product recommendations element
              const recommendations = tempDiv.querySelector("product-recommendations")
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML
              }

              // Extract and execute scripts
              const scripts = tempDiv.querySelectorAll("script")
              scripts.forEach((oldScript) => {
                if (!oldScript.hasAttribute("data-skip")) {
                  // Replace 'data-skip' with your attribute
                  const newScript = document.createElement("script")
                  Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value))
                  newScript.textContent = oldScript.textContent
                  document.body.appendChild(newScript)
                }
              })
            })
            .catch((e) => {
              console.error(e)
            })
        }

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this)
      }
    },
  )
} else {
  console.error("product-recommendations is already defined")
}
